import api from './api'

const findByNumCad = () => api.get('users/get-user-profile-senior/')

export { findByNumCad }
